module.exports = __webpack_public_path__ + "img/freeDNS.c2c882f.svg";